import React from "react";
import MCard from "@mui/material/Card";

const Card = (props) => {
  return <MCard {...props} />;
};

export default Card;
